import Icon from '@material-ui/icons/BookmarkBorder';
import React from 'react';
import { CreateButton } from '../../../../buttons';
import { EditDialog, Filter, ResourceList } from '../../../../controllers';
import { EnumField, TextField } from '../../../../fields';
import { BooleanInput, EnumInput, KidScriptInput, TextInput } from '../../../../inputs';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <TextInput
          source="object"
        />
        <KidScriptInput
          source="kidscript"
        />
        <TextInput
          source="position"
        />
        <EnumInput
          source="display"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        fixedValue={{ mission_step_id: props.parentResource.id }}
        {...props}
      >
        <TextInput
          source="object"
        />
        <KidScriptInput
          source="kidscript"
        />
        <TextInput
          source="position"
        />
        <EnumInput
          source="display"
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="object"
        />
        <TextField
          source="kidscript"
        />
        <TextField
          source="position"
        />
        <EnumField
          source="display"
        />
      </ResourceList>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
